/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['leaflet'], function(L) {
    'use strict';
    return function(position) {
        var div = L.DomUtil.create('div', 'tomtom-point-content__coordinates');

        div.innerHTML = position.lat + ', ' + position.lng;
        return div;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/coordinatesContent.js